const cb150rData = {
  slug: "cb150r-streetfire",
  name: "Honda CB150R StreetFire",

  hero: {
    shortDescription:
      "Motor sport naked premium dengan desain agresif dan performa bertenaga untuk pengendara urban",

    variants: [
      {
        key: "stinger-red-black",
        label: "Standard",
        fullName: "Honda New CB150R StreetFire Stinger Red Black",
        startPrice: 34874000,
      },
      {
        key: "se-grey",
        label: "Special Edition",
        fullName:
          "Honda New CB150R StreetFire Special Edition Armored Matte Grey",
        startPrice: 35744000,
      },
      {
        key: "se-black",
        label: "Special Edition",
        fullName:
          "Honda New CB150R StreetFire Special Edition Raptor Matte Black",
        startPrice: 35744000,
      },
    ],

    slides: [
      {
        variantKey: "stinger-red-black",
        image: "/assets/motor/produk/cb150r/Cb150r-Stinger-Red-Black.webp",
        specs: {
          engine: "149,16 cc, 4 Langkah, DOHC, 4 Katup, Pendingin Cairan",
          power: "12,4 kW (16,9 PS) / 9.000 rpm",
          smartKey: true,
        },
      },
      {
        variantKey: "se-grey",
        image: "/assets/motor/produk/cb150r/Cb150r-Armored-Matte-Grey-Special-Edition.webp",
        specs: {
          engine: "149,16 cc, 4 Langkah, DOHC, 4 Katup, Pendingin Cairan",
          power: "12,4 kW (16,9 PS) / 9.000 rpm",
          smartKey: true,
        },
      },
      {
        variantKey: "se-black",
        image: "/assets/motor/produk/cb150r/Cb150r-Raptor-Matte-Black-Special-Edition.webp",
        specs: {
          engine: "149,16 cc, 4 Langkah, DOHC, 4 Katup, Pendingin Cairan",
          power: "12,4 kW (16,9 PS) / 9.000 rpm",
          smartKey: true,
        },
      },
    ],
  },

  description: {
    sections: [
      {
        type: "paragraph",
        text:
          "Honda CB150R StreetFire merupakan motor sport naked premium yang mengusung desain agresif khas big bike Honda dengan performa tinggi dan fitur modern.",
      },
      {
        type: "paragraph",
        text:
          "Dibekali mesin 150cc DOHC 4 katup berpendingin cairan, CB150R StreetFire menawarkan akselerasi responsif dan karakter mesin bertenaga untuk kebutuhan berkendara harian maupun hobi.",
      },
      {
        type: "heading",
        text: "Desain Neo Sports Café",
      },
      {
        type: "paragraph",
        text:
          "Desain modern dengan lampu depan full LED, bodi berotot, serta rangka kokoh memberikan kesan motor besar yang premium dan maskulin.",
      },
      {
        type: "heading",
        text: "Teknologi dan Keamanan Modern",
      },
      {
        type: "paragraph",
        text:
          "Dilengkapi fitur Assist & Slipper Clutch, Honda Smart Key System, serta ABS dual channel untuk meningkatkan kenyamanan dan keselamatan berkendara.",
      },
    ],
  },

  specificationsDetail: {
    mesin: [
      [
        "Tipe Mesin",
        "4 Langkah, DOHC, 4 Katup, Pendingin Cairan",
      ],
      ["Sistem Suplai Bahan Bakar", "PGM-FI"],
      ["Kapasitas Mesin", "149,16 cc"],
      ["Daya Maksimum", "12,4 kW (16,9 PS) / 9.000 rpm"],
      ["Torsi Maksimum", "13,8 Nm / 7.000 rpm"],
      ["Transmisi", "Manual, 6 Percepatan"],
    ],

    rangka: [
      ["Tipe Rangka", "Diamond Steel Frame"],
      ["Suspensi Depan", "Upside Down (USD)"],
      ["Suspensi Belakang", "Monoshock"],
      ["Rem Depan", "Cakram dengan ABS"],
      ["Rem Belakang", "Cakram dengan ABS"],
    ],

    dimensi: [
      ["Panjang x Lebar x Tinggi", "1.973 x 822 x 1.053 mm"],
      ["Tinggi Jok", "795 mm"],
      ["Jarak Sumbu Roda", "1.293 mm"],
      ["Berat", "136 kg"],
    ],

    kapasitas: [
      ["Kapasitas Tangki Bahan Bakar", "12 Liter"],
    ],

    kelistrikan: [
      ["Sistem Pengapian", "Full Transistorized"],
      ["Tipe Aki", "12V MF"],
      ["Sistem Starter", "Electric Starter"],
    ],
  },

  fullFeatures: {
    title: "Fitur Unggulan Honda CB150R StreetFire",
    items: [
      {
        title: "Mesin 150cc DOHC",
        desc:
          "Mesin bertenaga dengan karakter responsif untuk performa maksimal di berbagai kondisi.",
      },
      {
        title: "Assist & Slipper Clutch",
        desc:
          "Membuat perpindahan gigi lebih ringan dan mencegah roda belakang selip saat engine brake.",
      },
      {
        title: "Upside Down Front Suspension",
        desc:
          "Suspensi depan USD yang meningkatkan stabilitas dan tampilan premium.",
      },
      {
        title: "Dual Channel ABS",
        desc:
          "Sistem pengereman ABS pada roda depan dan belakang untuk keamanan ekstra.",
      },
      {
        title: "Honda Smart Key System",
        desc:
          "Sistem keyless dengan alarm dan answer back system untuk keamanan modern.",
      },
      {
        title: "Full LED Lighting System",
        desc:
          "Sistem pencahayaan full LED yang modern dan memberikan visibilitas optimal.",
      },
      {
        title: "Panel Meter Full Digital",
        desc:
          "Panel meter digital informatif dengan tampilan futuristik dan mudah dibaca.",
      },
    ],
  },
};

export default cb150rData;
